// src/components/StagingRibbon.js
//
// A diagonal "STAGING" band across the bottom-right corner, like Flutter's
// debug banner, so a staging tab is never mistaken for production. It mirrors
// the phone's ribbon (mobile utils/EnvironmentRibbon.kt): same corner, same
// deep orange, white bold text.
//
// Staging is recognised by the Firebase project the build was made for, which
// covers staging.traklog.app, shootstoreshare2025-dev.web.app and a local
// `npm start` pointed at staging alike. It never takes a click: the band sits
// over the page with pointer events off.
import React from 'react';
import { Box } from '@mui/material';

const STAGING_PROJECT_ID = 'shootstoreshare2025-dev';

// The phone's BAND_COLOUR, Color.argb(0xE0, 0xE6, 0x51, 0x00).
const BAND_COLOUR = 'rgba(230, 81, 0, 0.88)';

export function isStagingProject(projectId) {
  return projectId === STAGING_PROJECT_ID;
}

export default function StagingRibbon({ projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID }) {
  if (!isStagingProject(projectId)) return null;

  return (
    <Box
      data-testid="staging-ribbon"
      aria-hidden="true"
      sx={{
        position: 'fixed',
        right: 0,
        bottom: 0,
        width: 120,
        height: 120,
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex: (theme) => theme.zIndex.tooltip + 1,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          right: -42,
          bottom: 22,
          width: 170,
          transform: 'rotate(-45deg)',
          bgcolor: BAND_COLOUR,
          color: '#fff',
          textAlign: 'center',
          font: '700 12px/26px system-ui, sans-serif',
          letterSpacing: '0.12em',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
        }}
      >
        STAGING
      </Box>
    </Box>
  );
}
